import milestone from '@/api/project-mgt/project-milestone'
import attachment from '@/api/project-mgt/module-attchment'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  fetch(context, attrubutes = {}) {
    return milestone.get({ params: attrubutes })
  },
  store(context, data) {
    return milestone.store(data)
  },
  update(context, { id, data }) {
    return milestone.update(id, data)
  },
  destroy(context, id) {
    return milestone.destroy(id)
  },
  find(context, id) {
    return milestone.find(id)
  },
  formViewModel(context, attrubutes = {}) {
    return milestone.formViewModel({ params: attrubutes })
  },
  getTask(context, params) {
    return milestone.getTask({ params })
  },
  history(context, params) {
    return milestone.history({ params })
  },
  attachFile(context, data) {
    return attachment.store(data)
  },
  deleteAttachment(context, id) {
    return attachment.destroy(id)
  }
}
